export default "__VITE_ASSET__Dn9YR4GJ__"